<div class="p-grid">
	<div class="p-col-12 p-md-4 display-6">Venue Administration</div>
	<div class="p-col-12 p-md-4">
		<span class="p-float-label">
			<p-dropdown
				#venueListSelect
				[options]="venueList"
				optionLabel="displayName"
				name="venueList"
				[(ngModel)]="selectedVenue"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				filterBy="displayName, key,name 	"
			></p-dropdown>
			<label for="venueList">Venue</label>
		</span>
	</div>
	<div class="p-col-12 p-md-4 d-flex">
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				[saveDisabled]="!changesToSave"
				(onSaveChange)="onSave()"
			></app-record-control-footer>
		</div>
	</div>
</div>

<p-tabView *ngIf="venueList?.length > 0">
	<p-tabPanel headerStyleClass="p-tab-header">
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'cog']" class="me-4" size="lg"></fa-icon>
			Setup
		</ng-template>
		<div class="card">
			<app-venue-setup [(changesToSave)]="changesToSave" [venue]="selectedVenue"></app-venue-setup>
		</div>
	</p-tabPanel>
	<p-tabPanel headerStyleClass="p-tab-header">
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'code']" class="me-4" size="lg"></fa-icon>
			Integrations
		</ng-template>
		<div class="card">
			<app-venue-integrations [(changesToSave)]="changesToSave" [venue]="selectedVenue"></app-venue-integrations>
		</div>
	</p-tabPanel>
	<p-tabPanel headerStyleClass="p-tab-header">
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'id-card-alt']" class="me-4" size="lg"></fa-icon>
			Licenses
		</ng-template>
		<div class="card">
			<app-venue-licenses [(changesToSave)]="changesToSave" [venue]="selectedVenue"></app-venue-licenses>
		</div>
	</p-tabPanel>
</p-tabView>
